import { SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

export const CREATE_SOURCE_WIDGET_INPUT_WIDTH = 480;

export const ALL_SOURCES: SourceType[] = [
  SourceType.UNSPECIFIED,
  SourceType.FILE_UPLOAD,
  SourceType.WEBHOOK,
  SourceType.TEXT,
  SourceType.SLACK,
  SourceType.JIRA,
  SourceType.LINEAR,
  SourceType.NETSUITE,
  SourceType.BROWSERBASE,
  SourceType.CLICKHOUSE,
  SourceType.MYSQL,
  SourceType.SNOWFLAKE,
  SourceType.GOOGLE_DRIVE,
  SourceType.S3,
  SourceType.SALESFORCE,
  SourceType.ATTIO,
  SourceType.NOTION,
  SourceType.POSTGRES,
  SourceType.BIGQUERY,
  SourceType.HUBSPOT,
  SourceType.GITHUB,
  SourceType.CONFLUENCE,
  SourceType.WIKIPEDIA,
];

export const SOURCE_TYPE_TO_PARAM_MAP: Record<SourceType, string | undefined> = {
  [SourceType.UNSPECIFIED]: undefined,
  [SourceType.FILE_UPLOAD]: "fileUpload",
  [SourceType.WEBHOOK]: "webhook",
  [SourceType.TEXT]: "text",
  [SourceType.SLACK]: "slack",
  [SourceType.JIRA]: "jira",
  [SourceType.LINEAR]: "linear",
  [SourceType.NETSUITE]: "netsuite",
  [SourceType.BROWSERBASE]: "browserbase",
  [SourceType.CLICKHOUSE]: "clickhouse",
  [SourceType.MYSQL]: "mysql",
  [SourceType.SNOWFLAKE]: "snowflake",
  [SourceType.GOOGLE_DRIVE]: "googleDrive",
  [SourceType.S3]: "s3",
  [SourceType.SALESFORCE]: "salesforce",
  [SourceType.ATTIO]: "attio",
  [SourceType.NOTION]: "notion",
  [SourceType.POSTGRES]: "postgres",
  [SourceType.BIGQUERY]: "bigquery",
  [SourceType.HUBSPOT]: "hubspot",
  [SourceType.GITHUB]: "github",
  [SourceType.CONFLUENCE]: "confluence",
  [SourceType.WIKIPEDIA]: "wikipedia",
};

export const PARAM_TO_SOURCE_TYPE_MAP: Record<string, SourceType> = {
  fileUpload: SourceType.FILE_UPLOAD,
  webhook: SourceType.WEBHOOK,
  text: SourceType.TEXT,
  browserbase: SourceType.BROWSERBASE,
  wikipedia: SourceType.WIKIPEDIA,
};
